import React from "react";

import {
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { Logo } from "@hubcapp/components";

import { LadderImage } from "@hubcapp/components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: "10vh",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    background: "#F2F2F2",
    height: "100vh",
  },
  logoContainer: {
    marginBottom: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
  image: {
    maxWidth: "100%",
    width: 560,
    maxHeight: 300,
    height: "auto",
  },
  textContainer: {
    display: "flex",
    justifyContent: "center",
  },
  text: {
    maxWidth: "15rem",
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "center",
  },
}));

const Error500 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className={classes.root}>
      <Grid container justify="center" className={classes.logoContainer}>
        <Logo />
      </Grid>

      <Grid container justify="center" className={classes.textContainer}>
        <Typography
          align="center"
          variant={mobileDevice ? "h4" : "h1"}
          className={classes.text}
        >
          Hubcapp is down for maintenance
        </Typography>
      </Grid>

      <Grid container justify="center" className={classes.imageContainer}>
        <LadderImage />
      </Grid>
    </div>
  );
};

export default Error500;
